import React, { useContext, useMemo } from 'react';

import PasswordChangePanel from '../components/panels/PasswordChangePanel';
import { AuthContext } from '../contexts/authContext';
import { useSelectedCarrier } from '../hooks/apiHooks';
import Layout from '../layout';
import { UserRole } from '../models/User';

const CarrierPasswordPage = ({ routes }) => {
  const { authUser } = useContext(AuthContext);
  const { selectedCarrier } = useSelectedCarrier();

  const isAdmin = useMemo(
    () => [UserRole.SUPER_ADMIN, UserRole.ADMIN].includes(authUser.role),
    [authUser.role]
  );

  if (!selectedCarrier && authUser?.role !== UserRole.CARRIER) {
    return null;
  }

  return (
    <Layout
      menuIndex={isAdmin ? 1 : 0}
      routes={routes}
      showCarriersNavigation={isAdmin}
    >
      <PasswordChangePanel
        id="user"
        title={
          authUser?.role === UserRole.CARRIER
            ? 'Change User Password'
            : 'Change Admin Password'
        }
      />
    </Layout>
  );
};

export default CarrierPasswordPage;
